import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { format } from "date-fns";
import { useState } from "react";
import { ProfissionalSetor } from "../../ProfissionalSetor/ProfissionalSetor";
import { Typography, Alert, Menu, MenuItem, Divider } from "@mui/material";
import { LoadingButton } from "../../../components/Loading";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import { useSave } from "../useSave";
import Dialog from "@mui/material/Dialog";
import { PessoaBusca } from "../../PessoaBusca/PessoaBusca";
import DescriptionIcon from "@mui/icons-material/Description";
import IconButton from "@mui/material/IconButton";
import { PessoaEvolucao } from "./PessoaEvolucao";
import LinearProgress from "@mui/material/LinearProgress";
import CancelIcon from "@mui/icons-material/Cancel";
import { useMessage } from "../../Message/MessageContext";
import { useEffect } from "react";
import { DadosImpressao } from "./DadosImpressao";
import { statusAgendamento } from "../../Agendamento/AgendamentoContext";
import { RemoverPessoa } from "./RemoverPessoa";
import DatePicker from "@mui/lab/DatePicker";
import { useNavigate } from "react-router-dom";
import { Cancelar } from "../Cancelar";

export function Atendimento({ atendimentoId }) {
  const [pessoaEvolucao, setPessoaEvolucao] = useState(null);
  const { setSuccess } = useMessage();
  const [anchorPrintEl, setAnchorPrintEl] = useState(null);
  const [agendamentoIdToCancel, setAgendamentoIdToCancel] = useState(undefined);
  const [printType, setPrintType] = useState("");
  const navigate = useNavigate();
  const {
    addPaciente,
    save,
    isLoading,
    isSaving,
    pessoaBuscaDialog,
    setPessoaBuscaDialog,
    pacientes,
    removePaciente,
    setorAtendimento,
    setSetorAtendimento,
    profissional,
    setProfissional,
    dataAgendamento,
    dataAtendimento,
    setDataAgendamento,
    descricao,
    setDescricao,
    canEdit,
    status,
    updatePaciente,
    savedItem,
    profissionalAdicional,
    setProfissionalAdicional,
  } = useSave(atendimentoId);

  const [pacienteToRemove, setPacienteToRemove] = useState(undefined);

  const onSubmit = async (e) => {
    e.preventDefault();
    save({ isAgendamento: false, status: statusAgendamento.realizado });
  };

  const print = (type) => {
    setPrintType(type);
    setAnchorPrintEl(null);
  };

  const remove = (paciente) => {
    if (!atendimentoId) {
      setPacienteToRemove(undefined);
      return removePaciente(paciente);
    }

    setPacienteToRemove(paciente);
  };

  useEffect(() => {
    if (isSaving === false) {
      setSuccess("Atendimento realizado com sucesso");
      navigate(`/grupo/atendimento/${savedItem.mainAtendimento.id}`);
    }
  }, [isSaving]);

  useEffect(() => {
    if (printType) {
      window.print();
      setPrintType("");
    }
  }, [printType]);

  return (
    <>
      <form onSubmit={onSubmit}>
        <Grid container spacing={2}>
          {isLoading && (
            <Grid item xs={12}>
              <LinearProgress />
            </Grid>
          )}
          <Grid item xs={12} sm={4} md={4}>
            <DatePicker
              autoOk
              fullWidth
              autoFocus
              ampm={false}
              disablePast
              value={dataAgendamento}
              onChange={setDataAgendamento}
              inputFormat="dd/MM/yyyy HH:mm"
              inputVariant="outlined"
              label={atendimentoId ? "Ref. ao agendamento" : "Data e hora"}
              renderInput={(p) => <TextField required {...p} fullWidth />}
              readOnly={!!dataAtendimento}
            />
          </Grid>

          <ProfissionalSetor
            readOnly={!!dataAtendimento}
            gridSetorProps={{ xs: 12, sm: 8 }}
            gridProfissionalProps={{ xs: 12 }}
            setorAtendimento={setorAtendimento || ""}
            onChangeSetor={(e, setorAtendimento) =>
              setSetorAtendimento(setorAtendimento)
            }
            profissional={profissional}
            onChangeProfissional={(e, profissional) =>
              setProfissional(profissional)
            }
            profissionalAdicional={profissionalAdicional}
            onChangeProfissionaisAdicionais={(e, profissionalAdicional) =>
              setProfissionalAdicional(profissionalAdicional)
            }
          />
          <Grid item xs={12}>
            <Typography fontWeight="bold">Evolução</Typography>
            <TextField
              fullWidth
              multiline
              rows={5}
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              margin="normal"
              variant="outlined"
              placeholder="Descreva a evolução do atendimento em grupo..."
            />
          </Grid>
          <DadosImpressao printType={printType} pacientes={pacientes} />
          <Grid item xs={12} className="no-print">
            <Typography fontWeight="bold">Pacientes</Typography>
            {pacientes.length > 0 ? (
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>Pront.</TableCell>
                    <TableCell>
                      <Tooltip title="Prontuário físico">
                        <span>Físico</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Ação</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pacientes.map((paciente) => (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={paciente.id}
                      sx={{ cursor: "pointer" }}
                      onClick={() => {}}
                    >
                      <TableCell>{paciente.id}</TableCell>
                      <TableCell>{paciente.numeroProntuario}</TableCell>
                      <TableCell>{paciente.nome}</TableCell>
                      <TableCell>{paciente.status || status}</TableCell>
                      <TableCell align="right">
                        <Tooltip title="Adicionar evolução do paciente">
                          <IconButton
                            color="info"
                            onClick={() => setPessoaEvolucao(paciente)}
                          >
                            <DescriptionIcon />
                          </IconButton>
                        </Tooltip>
                        {!dataAtendimento && (
                          <Tooltip title="Remover paciente do atendimento em grupo">
                            <IconButton
                              color="error"
                              onClick={() => remove(paciente)}
                            >
                              <CancelIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Typography>Nenhum paciente registrado</Typography>
            )}
          </Grid>
          {!dataAtendimento && (
            <Grid item xs={12}>
              <Button
                size="small"
                variant="outlined"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => setPessoaBuscaDialog(true)}
              >
                Pacientes
              </Button>
            </Grid>
          )}
          <Grid item xs={6} sm={4}>
            <LoadingButton
              type="submit"
              loading={isSaving || isLoading}
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              startIcon={<SaveIcon />}
              disabled={!canEdit || isSaving || isLoading}
            >
              {dataAtendimento ? "Atualizar" : "Salvar"}
            </LoadingButton>
          </Grid>
          {canEdit && !dataAtendimento && atendimentoId && (
            <Grid item xs={6} sm={4}>
              <Button
                fullWidth
                variant="outlined"
                color="error"
                size="large"
                onClick={() => setAgendamentoIdToCancel(atendimentoId)}
                startIcon={<CancelIcon />}
              >
                Cancelar
              </Button>
            </Grid>
          )}
          <Grid item xs={6} sm={4}>
            <Button
              fullWidth
              variant="outlined"
              size="large"
              onClick={(event) => setAnchorPrintEl(event.currentTarget)}
              startIcon={<PrintIcon />}
            >
              Imprimir
            </Button>
          </Grid>
          {!canEdit && !!profissional?.id && (
            <Grid item xs={12} className="no-print">
              <Alert severity="warning">
                O atendimento em grupo pode ser{" "}
                {dataAtendimento ? "atualizado " : "realizado "}
                apenas pelo profissional responsável
              </Alert>
            </Grid>
          )}
          {dataAtendimento && (
            <Grid item xs={12}>
              <Alert severity="info">
                Atendimento realizado em{" "}
                <b>{format(new Date(dataAtendimento), "dd/MM/yyyy H:mm")}</b>{" "}
                pelo profissional <b>{profissional.nome}</b>
              </Alert>
            </Grid>
          )}
        </Grid>
        <Dialog
          open={pessoaBuscaDialog}
          onClose={() => setPessoaBuscaDialog(false)}
          fullWidth
          maxWidth="md"
        >
          <PessoaBusca
            onSelect={addPaciente}
            onCancel={() => setPessoaBuscaDialog(false)}
            cancelLabel="Concluir"
          />
        </Dialog>
        <PessoaEvolucao
          onClose={(evolucao) => {
            setPessoaEvolucao(null);
            if (evolucao !== null)
              addPaciente({ ...pessoaEvolucao, descricao: evolucao });
          }}
          pessoa={pessoaEvolucao}
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorPrintEl}
          open={!!anchorPrintEl}
          onClose={() => setAnchorPrintEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => print("all")}>Todos</MenuItem>
          <Divider />
          {pacientes
            .filter(
              (p) =>
                p.status === statusAgendamento.realizado ||
                p.status === statusAgendamento.emAberto
            )
            .map((paciente) => (
              <MenuItem key={paciente.id} onClick={() => print(paciente.id)}>
                {paciente.nome}
              </MenuItem>
            ))}
        </Menu>
      </form>
      {agendamentoIdToCancel && (
        <Cancelar
          agendamentoId={agendamentoIdToCancel}
          onClose={(data) => {
            setAgendamentoIdToCancel(undefined);
            if (data) navigate("/grupo/atendimento/");
          }}
        />
      )}
      {pacienteToRemove && (
        <RemoverPessoa
          dataAgendamento={dataAgendamento}
          setorAtendimento={setorAtendimento}
          paciente={pacienteToRemove}
          onClose={(paciente) => {
            if (paciente) updatePaciente(paciente);
            setPacienteToRemove(undefined);
          }}
        />
      )}
    </>
  );
}
